import { useMutation, useQuery } from "@apollo/react-hooks";
import { Layout } from "antd";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import logoImg from "../../Assets/Images/logo.png";
import { FooterPage } from "../../Components/Footer/BaseFooter";
import { DashboardHeader } from "../../Components/Header/DashboardHeader";
import { Loader } from "../../Components/Loader";
import { DashboardSidebar } from "../../Components/Sidebar/Dashboard";
import { UPDATE_USER_LAST_SCREEN } from "../../Graphql/mutations";
import { GET_LAST_SCREEN } from "../../Graphql/queries";
import "./Dashboard.less";

export const DashboardTemplate = ({ title, children, userData }) => {
	const history = useHistory();
	const [isSideBarOpen, setIsSideBarOpen] = useState(false);
	const [menu, setMenu] = useState([]);

	const toggleSideBarMenu = () => {
		setIsSideBarOpen((sideBarStatus) => !sideBarStatus);
	};
	const { data: lastScreenData } = useQuery(GET_LAST_SCREEN, {
		variables: { user_id: localStorage.getItem("user_id") },
		fetchPolicy: "cache-and-network",
	});

	const [UPDATE_USER_LAST_SCREEN_MUTATION] = useMutation(
		UPDATE_USER_LAST_SCREEN
	);

	useEffect(() => {
		if (lastScreenData?.getUsersById.last_screen !== "/" && menu.length > 0) {
			UPDATE_USER_LAST_SCREEN_MUTATION({
				variables: {
					user_id: localStorage.getItem("user_id"),
					last_screen: "/",
				},
			});
		}
	}, [menu, lastScreenData]);

	useEffect(() => {
		if (userData) {
			switch (userData?.getUsersById?.user_access?.access_id) {
				case "1":
					setMenu([
						{
							title: "Dashboard",
							link: "/",
							custIcon: "dashboard",
							key: "dashboard",
						},
						{
							title: "Locations",
							link: "/location",
							custIcon: "location",
							key: "location",
						},
						{
							title: "Employee",
							link: "/employee",
							custIcon: "employees",
							key: "employee",
						},
						{
							title: "Tasks",
							link: "/tasks",
							custIcon: "tasks",
							key: "tasks",
						},
						{
							title: "Announcements",
							link: "/announcements",
							custIcon: "announcement",
							key: "announcements",
						},
						{
							title: "Reports",
							link: "/reports/location-performance",
							custIcon: "reports",
							key: "reports",
						},
						{
							title: "Settings",
							link: "/settings/profile",
							custIcon: "setting",
							key: "settings",
						},
						{
							title: "Videos",
							link: "/videos",
							custIcon: "ic_videos",
							key: "videos",
						},
					]);
					break;

				case "2":
				case "3":
				case "4":
					setMenu([
						{
							title: "Dashboard",
							link: "/",
							custIcon: "dashboard",
							key: "dashboard",
						},
						{
							title: "Location",
							link: "/location",
							custIcon: "location",
							key: "location",
						},
						{
							title: "Employees",
							link: "/employee",
							custIcon: "employees",
							key: "employee",
						},
						{
							title: "Tasks",
							link: "/tasks",
							custIcon: "tasks",
							key: "tasks",
						},
						{
							title: "Announcements",
							link: "/announcements",
							custIcon: "announcement",
							key: "announcements",
						},
						{
							title: "Reports",
							link: "/reports/location-performance",
							custIcon: "reports",
							key: "reports",
						},
						{
							title: "Settings",
							link: "/settings/profile",
							custIcon: "setting",
							key: "settings",
						},
						{
							title: "Videos",
							link: "/videos",
							custIcon: "ic_videos",
							key: "videos",
						},
					]);
					break;

				default:
				case "5":
					let employeeMenu = [
						{
							title: "My Tasks",
							link: "/tasks/my-tasks",
							custIcon: "tasks",
							key: "tasks",
						},
						{
							title: "Settings",
							link: "/settings/profile",
							custIcon: "setting",
							key: "settings",
						},
						{
							title: "Videos",
							link: "/videos",
							custIcon: "ic_videos",
							key: "videos",
						},
					];
					let allowedPage = employeeMenu.some((s) => {
						if (history.location.pathname === "/") {
							return s.link === "/";
						} else {
							return s.link.includes(history.location.pathname.split("/")[1]);
						}
					});
					if (!allowedPage) {
						if (userData?.getUsersById?.user_access?.access_id === "5") {
							history.push("tasks/my-tasks");
						} else {
							history.push(employeeMenu[0].link);
						}
						setMenu(employeeMenu);
					} else {
						setMenu(employeeMenu);
					}
					break;
			}
		}
	}, [userData, history]);

	if (menu.length <= 0) {
		return <Loader className="full_screen" />;
	}

	return (
		<Layout className="rootLayout">
			<DashboardSidebar
				fullLogo={
					userData?.getUsersById?.user_location_maps[0]?.businessDetails
						?.brand_logo
				}
				smallLogo={
					userData?.getUsersById?.user_location_maps[0]?.businessDetails
						?.brand_icon
				}
				menuOptions={menu}
				isSideBarOpen={isSideBarOpen}
				toggleSideBarMenu={toggleSideBarMenu}
			/>
			<Layout className="site-layout">
				{!isSideBarOpen && (
					<div className="overlay" onClick={toggleSideBarMenu}></div>
				)}
				<div className="mobileHeader">
					<div className="logo">
						<img src={logoImg} className="big" alt="" />
					</div>
					<div className="hamburgarTop" onClick={toggleSideBarMenu}>
						<span></span>
						<span></span>
						<span></span>
					</div>
				</div>
				<div className="site_wrapper">
					<DashboardHeader
						isSideBarOpen={isSideBarOpen}
						toggleSideBarMenu={toggleSideBarMenu}
						initials={
							userData?.getUsersById?.first_name?.charAt(0).toUpperCase() +
							userData?.getUsersById?.last_name?.charAt(0).toUpperCase()
						}
						pageName={title}
						src={userData?.getUsersById?.profile_image}
						userData={userData}
					/>
					<div className="page_wrapper">{children}</div>
				</div>
				<FooterPage />
			</Layout>
		</Layout>
	);
};
